module.exports = __webpack_public_path__ + "assets/img/register_date-2a7fb228.png";